import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=2cfbe11e&"
import script from "./HelpComponent.vue?vue&type=script&lang=js&"
export * from "./HelpComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports